export interface BcpDuplicationEntryModalProps {
  headerLabel?: string;
  bodyLabel?: string;
  increaseLabel?: string;
  newLineLabel?: string;
  cancelLabel?: string;
  addToWishlistUrl: string;
  productCode: string;
  quantity?: number;
}

export interface BcpDuplicationEntryModalState {
  selectWishlistDialogVisible: boolean;
}

export enum PreventMergeEntry {
  PREVENT = "PREVENT",
  MERGE = "MERGE",
}
